import { render, staticRenderFns } from "./ChatGPTEditorProductRecommendation.vue?vue&type=template&id=6b04f5c5&"
import script from "./ChatGPTEditorProductRecommendation.vue?vue&type=script&lang=js&"
export * from "./ChatGPTEditorProductRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports